import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "./api";
import * as XLSX from "xlsx";

export default function ViewFilePage() {
  const { filename } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFile = async () => {
      try {
        const res = await API.get(`/view/${filename}`);
        console.log("Response from backend:", res.data);
        if (res.data.data) setData(res.data.data);
      } catch (err) {
        console.error("Error fetching file data:", err);
        alert("Error loading file");
      } finally {
        setLoading(false);
      }
    };

    fetchFile();
  }, [filename]);

  const handleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  if (loading)
    return (
      <div
        style={{
          padding: "50px",
          textAlign: "center",
          fontSize: "18px",
          color: "#555",
        }}
      >
        ⏳ Loading file data...
      </div>
    );

  return (
    <div
      style={{
        backgroundColor: "#f4f6fc",
        minHeight: "100vh",
        padding: "30px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/*  Header Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "15px 25px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          marginBottom: "30px",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "8px 15px",
            cursor: "pointer",
          }}
        >
          ⬅ Back
        </button>

        <h3 style={{ color: "#333", margin: 0 }}>
          📁 Viewing File:{" "}
          <span style={{ color: "#007bff" }}>{filename}</span>
        </h3>

        <button
          onClick={handleDownload}
          style={{
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "8px 15px",
            cursor: "pointer",
            fontWeight: 500,
          }}
        >
          ⬇ Download Excel
        </button>
      </div>

      {/* File Data Section */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          padding: "25px",
        }}
      >
        {data.length > 0 ? (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                textAlign: "left",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f1f3f6" }}>
                  {Object.keys(data[0]).map((key) => (
                    <th
                      key={key}
                      style={{
                        padding: "10px",
                        fontWeight: "600",
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      {key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((row, i) => (
                  <tr
                    key={i}
                    style={{
                      borderBottom: "1px solid #eee",
                      transition: "0.2s",
                    }}
                  >
                    {Object.keys(data[0]).map((key) => (
                      <td
                        key={key}
                        style={{
                          padding: "10px",
                          color: "#333",
                          fontSize: "14px",
                        }}
                      >
                        {row[key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#777" }}>
            No data found in this file.
          </p>
        )}
      </div>
    </div>
  );
}
